export const SET_FILES = "FILES/SET_FILES";
export const SET_FILE = "FILES/SET_FILE";
export const PENNDING_FILES = "FILES/PENNDING_FILES";
export const SET_PAGINATION = "FILES/SET_PAGINATION";
export const SET_ESTRUTURA = "FILES/SET_ESTRUTURA";
export const ADD_ESTRUTURA = "FILES/ADD_ESTRUTURA";
export const SET_LOADING = "FILES/SET_LOADING";
